module.exports = __webpack_public_path__ + "img/ps.6d6bfba0.png";